import Vue from 'vue'
import {
  Avatar,
  Alert,
  BackTop,
  Button,
  Col,
  Content,
  Checkbox,
  CheckboxGroup,
  Collapse,
  DatePicker,
  Drawer,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Divider,
  Form,
  FormItem,
  Header,
  Icon,
  InputNumber,
  Input,
  Layout,
  Menu,
  MenuItem,
  Modal,
  Option,
  OptionGroup,
  Page,
  Panel,
  Poptip,
  Radio,
  RadioGroup,
  Row,
  Select,
  Sider,
  Slider,
  Spin,
  Submenu,
  Switch,
  Table,
  TabPane,
  Tabs,
  Breadcrumb,
  BreadcrumbItem,
  Notice,
  Upload,
  TimePicker,
  LoadingBar,
  Tag,
  Tooltip,
  Tree,
  Timeline,
  TimelineItem,
  Progress,
  Scroll,
  Message,
  Badge,
  Steps,
  Step,
  List,
  ListItemMeta,
  Card,
  ListItem
} from 'view-design'

Vue.component('Alert', Alert)
Vue.component('Page', Page)
Vue.component('Panel', Panel)
Vue.component('Header', Header)
Vue.component('Row', Row)
Vue.component('Col', Col)
Vue.component('Collapse', Collapse)
Vue.component('Icon', Icon)
Vue.component('Table', Table)
Vue.component('Drawer', Drawer)
Vue.component('Dropdown', Dropdown)
Vue.component('DropdownMenu', DropdownMenu)
Vue.component('DropdownItem', DropdownItem)
Vue.component('Tabs', Tabs)
Vue.component('TabPane', TabPane)
Vue.component('Layout', Layout)
Vue.component('DatePicker', DatePicker)
Vue.component('Form', Form)
Vue.component('FormItem', FormItem)
Vue.component('Select', Select)
Vue.component('Option', Option)
Vue.component('OptionGroup', OptionGroup)
Vue.component('BackTop', BackTop)
Vue.component('Button', Button)
Vue.component('RadioGroup', RadioGroup)
Vue.component('Radio', Radio)
Vue.component('Content', Content)
Vue.component('Input', Input)
Vue.component('Slider', Slider)
Vue.component('Avatar', Avatar)
Vue.component('Menu', Menu)
Vue.component('MenuItem', MenuItem)
Vue.component('Submenu', Submenu)
Vue.component('i-switch', Switch)
Vue.component('Sider', Sider)
Vue.component('Modal', Modal)
Vue.component('Spin', Spin)
Vue.component('Breadcrumb', Breadcrumb)
Vue.component('BreadcrumbItem', BreadcrumbItem)
Vue.component('Notice', Notice)
Vue.component('Upload', Upload)
Vue.component('TimePicker', TimePicker)
Vue.component('LoadingBar', LoadingBar)
Vue.component('Tooltip', Tooltip)
Vue.component('Tree', Tree)
Vue.component('Checkbox', Checkbox)
Vue.component('CheckboxGroup', CheckboxGroup)
Vue.component('Tag', Tag)
Vue.component('Timeline', Timeline)
Vue.component('TimelineItem', TimelineItem)
Vue.component('Progress', Progress)
Vue.component('InputNumber', InputNumber)
Vue.component('Scroll', Scroll)
Vue.component('Message', Message)
Vue.component('Divider', Divider)
Vue.component('Poptip', Poptip)
Vue.component('Badge', Badge)
Vue.component('Steps', Steps)
Vue.component('Step', Step)
Vue.component('List', List)
Vue.component('ListItemMeta', ListItemMeta)
Vue.component('Card', Card)
Vue.component('ListItem', ListItem)

Vue.prototype.$Modal = Modal
Vue.prototype.$Notice = Notice
Vue.prototype.$Loading = LoadingBar
Vue.prototype.$Message = Message



// WEBPACK FOOTER //
// ./src/iView/index.js